import { MountApproveByCalculators } from '../approve-by-calculator';

main();

function main() {
    MountApproveByCalculators(document);
}
